import React from 'react'
import moment from 'moment'
import { useAuth } from '../../context/UserContext';
import utils from '../../utils';
import { MdEdit } from 'react-icons/md';
import UserEditModal from '../auth/UserEditModal';

function AccountSettings() {
    const { user } = useAuth()
    return (
        <div className='bg-surface-light dark:bg-surface-dark rounded-xl border border-border-light dark:border-border-dark  p-3 md:p-5 px-4 py-4 md:py-6 md:px-6 pb-6 space-y-5'>
            <div className="flex flex-col md:flex-row gap-4 md:justify-between">
                <div className="">
                    <h3 className="text-xl font-bold text-gray-800">
                        Account Information
                    </h3>
                    <p className="text-zinc-500 mt-1">Details on user Account</p>
                </div>
                <div>
                    <label
                        htmlFor="user-update-modal"
                        className="mt-4 sm:mt-0 flex items-center space-x-2 bg-primary text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors cursor-pointer"
                    >
                        <MdEdit className="text-base" />
                        <span>Edit Profile</span>
                    </label>
                </div>
            </div>
            <hr />
            <UserEditModal/>
            <div className='flex justify-center md:justify-start'>
                <div className="avatar placeholder">
                    {user?.image ? (
                        <div className="w-20 rounded-full">
                            <img src={user.image} alt={user.email} />
                        </div>
                    ) : (
                        <div className="bg-neutral text-white rounded-full w-20">
                            <span className="text-3xl">
                                {utils.makeProfileLetter(user)}
                            </span>
                        </div>
                    )}
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-4">
                {user?.full_name && (
                    <div>
                        <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            Full Name
                        </label>
                        <p className="mt-1 text-gray-800 dark:text-gray-200 font-medium">
                            {user.full_name}
                        </p>
                    </div>
                )}

                <div>
                    <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                        Email Address
                    </label>
                    <p className="mt-1 text-gray-800 dark:text-gray-200 font-medium">
                        {user?.email}
                    </p>
                </div>

                {user?.phone_number && (
                    <div>
                        <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                            Phone Number
                        </label>
                        <p className="mt-1 text-gray-800 dark:text-gray-200 font-medium">
                            {user.phone_number}
                        </p>
                    </div>
                )}

                <div>
                    <label className="text-sm font-medium text-gray-500 dark:text-gray-400">
                        Member Since
                    </label>
                    <p className="mt-1 text-gray-800 dark:text-gray-200 font-medium">
                        {user?.creation_time
                            ? moment(user.creation_time).fromNow()
                            : '-'}
                    </p>
                </div>

                <div className="md:col-span-2">
                    <label className="text-sm font-medium text-gray-500 dark:text-gray-400 mr-2">
                        Account Type:
                    </label>
                    <p className="mt-1 inline-flex flex-wrap items-center gap-2">
                        {user?.is_admin && (
                            <span className="px-3 py-1 bg-primary/10 text-primary dark:bg-red-900/30 dark:text-red-300 text-xs font-semibold rounded-full">
                                Admin
                            </span>
                        )}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default AccountSettings